module.exports = __webpack_public_path__ + "img/no.745b53a3.svg";